<template>
  <div class="app">
		<div class="row">
			<div class="col-md-12">
				<div class="box">
					<div class="box-header with-border">
						<h3 class="box-title">Режим "Live"</h3>
					</div>
					<div class="box-body">
						<div class="input">
							<textarea ref="input" v-model="form.input" class="form-control" @keyup="keyup"></textarea>
						</div>
						<div class="print-area-wrap">
							<div v-show="Object.keys(ticket).length > 0" id="print-area" class="print-area" style="font-family: 'Roboto', sans-serif;padding: 5px;margin: 0 auto;text-align: center;">
								<div class="print-area__username" style="font-size: 25px;font-weight: bold;">{{ ticket.first_name }}<br>{{ ticket.last_name }}</div>
								<barcode class="print-area__barcode" v-bind:value="ticket.id" height="20" display-value="false">
								</barcode>
								<div class="print-area__seat" style="	font-weight: bold;text-transform: uppercase;">{{ ticket.seat }}</div>
							</div>

							<div class="revision-area" v-if="Object.keys(revision).length > 0">
								<div class="revision-area__username">{{ revision.first_name }}<br>{{ revision.last_name }}</div>
								<div class="revision-area__seat" >{{ revision.seat }}</div>
								<div class="revision-area__category" >{{ revision.category }}</div>
							</div>
						</div>
					</div>
					<div class="box-footer">
						<router-link to="/" class="btn btn-default btn-flat pull-left">Вернуться к схеме бронирования</router-link>
						<router-link to="/live-custom" class="btn btn-info btn-flat pull-right">Ручной режим</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
	components: {
		'barcode': VueBarcode
	},
	data: function () {
		return {
			timer: null,
			ticket: {},
			revision: {},
			open: false,
			emailModalShow: false,
			alert: false,
			alertText: '',
			items: [],
			loading: true,
			form: {
				input: ''
			}
		}
	},
	mounted: function () {
		this.$refs.input.focus()
	},
	methods: {
		keyup: function () {
			clearTimeout(this.timer)
			this.timer = setTimeout(() => {
				let obj = this.getJson(this.form.input)
				if (obj !== false) {
					if (obj.hasOwnProperty('ticket_id')) {
						this.getTicket()
					} else {
						this.doRevision()
					}
				} else {
					this.form.input = ''
					return false
				}
			}, 500)
		},
		getTicket: function () {
			let params = JSON.parse(this.form.input)
			this.$http.get('https://tip24.ru/event/ajax/get-ticket', {
				params: {
					seat_id: params.ticket_id
				}
			}, {
			}).then(function (response) {
				this.revision = {}
				let data = response.data
				this.ticket = data
				this.print(data)
				this.form.input = ''
			}, function (response) {
				this.form.input = ''
			})
		},
		doRevision: function () {
			if (this.form.input < 1) {
				return false
			}

			this.ticket = {}
			this.$http.post('https://tip24.ru/event/ajax/revision', {
				seat_id: this.form.input
			}, {
			}).then(function (response) {
				let data = response.data
				this.revision = data
				this.form.input = ''
			}, function (response) {
				this.revision = {}
			})
		},
		print: function (data) {
			let win = window.open('', '', 'toolbar=0,scrollbars=1,status=0')
			setTimeout(() => {
				let html = document.getElementById('print-area')
				let bs = '<link href="https://fonts.googleapis.com/css?family=Roboto:400,700,900" rel="stylesheet">'
				win.document.write(bs)
				win.document.write(html.outerHTML)
				setTimeout(() => {
					win.print()
					win.close()
				}, 300)
			}, 100)
		},
		getJson: function (str) {
			try {
				var obj = JSON.parse(str)
			} catch (e) {
				return false
			}
			return obj
		},
		getQueryVariable: function (name) {
			var query = window.location.search.substring(1)
			var vars = query.split('&')
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=')
				if (decodeURIComponent(pair[0]) === name) {
					return decodeURIComponent(pair[1])
				}
			}
		},
		reset: function () {
			this.form.input = ''
			this.ticket = {}
		}
	}
}
</script>
<style>
.print-area-wrap {
	margin-bottom: 50px;
}
.input {
	margin-bottom: 50px;
}
.print-area {
	width: 303px;
	height: 151px;
	padding: 7px;
	margin: 0 auto;
	text-align: center;
	border: 1px solid #f1f1f1;
}

.print-area__username {
	font-size: 25px;
	font-weight: bold;
}

.print-area__seat {
	font-weight: bold;
	text-transform: uppercase;
}

.revision-area {
	width: 80rem;
	padding: 10px;
	margin: 0 auto;
	text-align: center;
	background: #f1f1f1;
}

.revision-area__username {
	font-size: 70px;
	font-weight: bold;
}

.revision-area__seat, .revision-area__category {
	font-size: 60px;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/live.vue